<template>
    <ul>
        <li v-for="(notification, index) in notifications.get()" :key="index">
            <toast
                :text="notification.text"
                :type="notification.type"
                :fade-seconds="0.5"
                :show-seconds="getShowSeconds(notification, index)"
            ></toast>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            toasts: {
                type: Array,
                default: []
            }
        },
        methods: {
            getShowSeconds(notification, index) {
                if (notification.duration !== undefined) {
                    return notification.duration;
                }
                return 3 + (index * 0.5);
            }
        },
        data() {
            return {
                notifications: this.$notifications
            }
        },
        mounted() {
            this.notifications.set(this.toasts);
        }
    }
</script>

<style scoped lang="scss">
    ul {
        position: fixed;
        top: 7%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1060;

        li {
            margin-bottom: 7px;
        }
    }
</style>
